import { ArrowLeft, LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from '@/constants/routes';
import { STORAGE_KEYS } from '@/constants/storage-keys';
import { useAuth } from '@/features/auth/AuthContext';

import { TimezoneSelect } from './TimezoneSelect';

export function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = () => {
    logout();
    navigate(ROUTES.LOGIN);
  };

  const goProjectHub = () => {
    localStorage.removeItem(STORAGE_KEYS.SELECTED_PROJECT_ID);
    navigate(ROUTES.PROJECTS);
  };

  return (
    <div className="border-t border-gray-200 px-5 py-4">
      <div className="mb-2 flex items-center justify-between">
        <div className="min-w-0">
          <p className="truncate text-xs font-medium text-gray-700">{user.name}</p>
          <p className="truncate text-[10px] text-gray-400">{user.role.toUpperCase()}</p>
        </div>
        <button
          onClick={handleLogout}
          className="ml-2 flex-shrink-0 text-xs text-gray-400 transition-colors hover:text-red-600"
          title="Sign out"
          aria-label="Sign out"
        >
          <LogOut className="h-4 w-4" />
        </button>
      </div>

      <TimezoneSelect />

      <div className="mt-2 border-t border-gray-100 pt-2">
        <button
          onClick={goProjectHub}
          className="flex items-center gap-1.5 text-xs text-gray-400 transition-colors hover:text-indigo-600"
        >
          <ArrowLeft className="h-3.5 w-3.5" aria-hidden="true" />
          All Projects
        </button>
      </div>
    </div>
  );
}
